const Avatar = ({ children }: any) => (
  <div data-testid="avatar">
    <span className="inline-block  flex items-center justify-center h-9 w-9 rounded-full border border-indigo-600 text-indigo-600 font-bold">
      {children}
    </span>
  </div>
)

export default Avatar
